export const FABRIC_INFO = [
  {
    name: "Everyday Georgette", slug: "everyday-georgette", image: "/images/products/naseem-ward.jpg",
    intro: "Genuine everyday Indian georgette — lightweight, softly grained and honest. The Naseem collection's fabric: a breeze for every day.",
    specs: [
      ["Texture", "Slightly grainy, matte georgette weave"],
      ["Weight & Feel", "Feather-light with a natural, airy fall"],
      ["Opacity", "Modest transparency — best with an undercap"],
      ["Drape", "Relaxed, natural everyday fall"],
      ["Shine", "None — honest matte finish"],
      ["Best For", "Daily wear, college, work, errands"],
    ],
    care: "Machine wash gentle or hand wash cold. Drip dry in the shade. Warm iron with a pressing cloth.",
  },
  {
    name: "Silk-Touch Print", slug: "silk-touch-print", image: "/images/products/hiba-ruwa.jpg",
    intro: "Lightweight, silky-soft fabric carrying artistic feather-and-floral prints traced with subtle gold. The Hiba collection's fabric — where art meets modesty.",
    specs: [
      ["Texture", "Smooth, soft surface with artistic all-over prints"],
      ["Weight & Feel", "Light and breathable, all-day comfort"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Soft, flowing fall"],
      ["Shine", "Matte base with delicate gold accents in the print"],
      ["Best For", "Everyday statements, work, gatherings"],
    ],
    care: "Hand wash cold with a gentle detergent. Drip dry in the shade. Cool iron on reverse to protect the print.",
  },
  {
    name: "Floral Embroidered", slug: "floral-embroidered", image: "/images/products/nayla-ward.jpg",
    intro: "A soft, breathable base embroidered with delicate pink-and-green floral blooms. The Nayla collection's fabric — everyday grace, effortless modesty.",
    specs: [
      ["Texture", "Soft weave with raised embroidered florals"],
      ["Weight & Feel", "Light and breathable"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Relaxed, graceful fall"],
      ["Shine", "Natural matte with tonal embroidery detail"],
      ["Best For", "Daily wear, work, casual elegance"],
    ],
    care: "Hand wash gently in cold water. Dry flat in the shade. Cool iron on reverse — never directly over the embroidery.",
  },
  {
    name: "Embroidered Marble Satin", slug: "embroidered-marble-satin", image: "/images/products/marba-qamar.jpg",
    intro: "Premium marble satin with a subtle sheen, finished with delicate embroidery. The Marba collection's fabric — subtle sheen, timeless grace.",
    specs: [
      ["Texture", "Smooth marble satin with fine embroidered detailing"],
      ["Weight & Feel", "Light with a fluid, luxurious hand"],
      ["Opacity", "Opaque — full coverage"],
      ["Drape", "Soft, luminous fall"],
      ["Shine", "Subtle marble-satin glow, never glossy"],
      ["Best For", "Occasions, evenings, celebrations"],
    ],
    care: "Hand wash cold or dry clean. Drip dry away from sunlight. Iron on reverse at the lowest setting, avoiding the embroidery.",
  },
  {
    name: "Floral Print", slug: "floral-print", image: "/images/products/falaa-haya.jpg",
    intro: "Lightweight, breathable fabric printed with soft floral blooms and a subtle sparkle. The Falaa collection's fabric — soft florals, everyday elegance.",
    specs: [
      ["Texture", "Smooth surface with soft printed blooms"],
      ["Weight & Feel", "Feather-light and breathable"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Easy, natural fall"],
      ["Shine", "Matte with a whisper of sparkle"],
      ["Best For", "Everyday wear, warm days, effortless styling"],
    ],
    care: "Hand wash cold. Drip dry in the shade. Cool iron on reverse to keep the print fresh.",
  },
  {
    name: "Satin Shimmer", slug: "satin-shimmer", image: "/images/products/munira-toot.jpg",
    intro: "A softly textured satin surface with a subtle reflective shimmer — radiant without ever being glossy. The Munira collection's fabric — a radiant touch for your journey.",
    specs: [
      ["Texture", "Fine slub-textured satin surface"],
      ["Weight & Feel", "Light with an effortless, fluid drape"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Soft, smooth fall"],
      ["Shine", "Subtle all-over shimmer, never metallic"],
      ["Best For", "Everyday elegance, work, gatherings"],
    ],
    care: "Hand wash cold with a gentle detergent. Drip dry away from sunlight. Cool iron on reverse if needed.",
  },
  {
    name: "Crinkle Tassel", slug: "crinkle-tassel", image: "/images/products/reem-ward.jpg",
    intro: "Fine linear crinkle pleats and delicate tasselled corners on a lightweight, breathable base. The Reem collection's fabric — a style that moves with you.",
    specs: [
      ["Texture", "Fine linear micro-pleated crinkle"],
      ["Weight & Feel", "Feather-light and breathable"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Relaxed, natural fall with gentle movement"],
      ["Shine", "Natural matte"],
      ["Details", "Corners finished with small tassels on gold beads"],
      ["Best For", "Effortless everyday wear"],
    ],
    care: "Hand wash cold and drip dry — the crinkle pleats reset naturally. Do not iron the pleats or the tassels.",
  },
  {
    name: "Lustrous Satin", slug: "lustrous-satin", image: "/images/products/lamees-rumman.jpg",
    intro: "Smooth, fluid satin with a soft glossy sheen that elevates every look. The Lamees collection's fabric — sheen that speaks elegance.",
    specs: [
      ["Texture", "Smooth, silken satin surface"],
      ["Weight & Feel", "Light and fluid, cool against the skin"],
      ["Opacity", "Opaque — full coverage"],
      ["Drape", "Radiant, liquid fall"],
      ["Shine", "Soft glossy satin sheen that shifts with the light"],
      ["Best For", "Occasions, evenings, celebrations"],
    ],
    care: "Hand wash cold or dry clean. Drip dry away from sunlight. Iron on reverse at the lowest setting.",
  },
  {
    name: "Stoned Georgette", slug: "stoned-georgette", image: "/images/products/raneem-nuhas.jpg",
    intro: "Lightweight georgette washed with a soft antique marbled tone and finished with delicate stone detailing that catches the light. The Raneem collection's fabric — beauty in every detail.",
    specs: [
      ["Texture", "Soft georgette with a gentle marbled wash and fine scattered stones"],
      ["Weight & Feel", "Light and fluid, easy to style"],
      ["Opacity", "Semi-sheer — pairs beautifully with an underscarf"],
      ["Drape", "Soft, graceful fall"],
      ["Shine", "Matte base with subtle points of light from the stones"],
      ["Best For", "Occasions, evenings, festive wear"],
    ],
    care: "Hand wash gently in cold water. Drip dry in the shade. Cool iron on reverse — never directly over the stone details.",
  },
  {
    name: "Marble Textured Hijab", slug: "marble-textured-hijab", image: "/images/products/ayla-asal.jpg",
    intro: "A softly textured hijab defined by its distinctive marble-like surface and graceful drape. The Ayla collection's signature — texture that speaks softly.",
    specs: [
      ["Texture", "Irregular marble-style crinkle — beautifully dimensional"],
      ["Weight & Feel", "Light, soft and breathable"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Relaxed, natural fall"],
      ["Shine", "Natural matte"],
      ["Best For", "Everyday wear, warm weather, all-day comfort"],
    ],
    care: "Gentle machine or hand wash cold. Air dry — the marble texture is part of the charm, no ironing needed.",
  },
  {
    name: "Imperial Satin", slug: "imperial-satin", image: "/images/products/zareen-shahraz.jpg",
    intro: "Smooth, fluid and luminous, with a subtle linear texture that catches the light as it moves. The Zareen collection's fabric — timeless shimmer for your everyday story.",
    specs: [
      ["Texture", "Subtle vertical linear texture on a smooth satin surface"],
      ["Weight & Feel", "Light with a fluid, liquid fall"],
      ["Opacity", "Opaque — full coverage"],
      ["Drape", "Soft, flowing and easy to shape"],
      ["Shine", "Refined luminous sheen that shifts across folds"],
      ["Best For", "Everyday elegance, work, evenings"],
    ],
    care: "Hand wash cold or dry clean. Iron on reverse at the lowest setting.",
  },
  {
    name: "Velvet Satin", slug: "velvet-satin", image: "/images/products/mahra-rumman.jpg",
    intro: "A velvety-soft brushed surface with a subdued luxe glow and a smooth, weighty drape. The Mahra collection's fabric — a richer kind of elegance.",
    specs: [
      ["Texture", "Soft brushed velvet face with a gentle mottled depth"],
      ["Weight & Feel", "Plush and soft in hand, warm against the skin"],
      ["Opacity", "Fully opaque"],
      ["Drape", "Smooth, generous fall that stays in place"],
      ["Shine", "Soft, subdued satin glow"],
      ["Best For", "Winter wear, evenings, occasions"],
    ],
    care: "Hand wash cold, gently — never wring. Dry flat in the shade. Steam lightly instead of ironing.",
  },
  {
    name: "Premium Chiffon", slug: "premium-chiffon", image: "/images/products/thuraya-asal.jpg",
    intro: "Flowing premium chiffon traced with fine vertical stone-line detailing. The Thuraya collection's fabric — graceful movement with a quiet sparkle.",
    specs: [
      ["Texture", "Smooth chiffon with fine vertical dotted stone-lines"],
      ["Weight & Feel", "Light and airy with a graceful fall"],
      ["Opacity", "Semi-sheer — pairs beautifully with an underscarf"],
      ["Drape", "Fluid, elegant and easy to style"],
      ["Shine", "Soft matte with delicate stone-line glints"],
      ["Best For", "Daily wear, work, festive days"],
    ],
    care: "Hand wash cold. Drip dry in the shade. Cool iron on low.",
  },
  {
    name: "Bubble Crochet", slug: "bubble-crochet", image: "/images/products/najwa-ward.jpg",
    intro: "A fine bubble texture finished with a delicate crochet edge — the signature of the Najwa collection. Soft dimension, handcrafted charm.",
    specs: [
      ["Texture", "Fine all-over bubble grain with a crochet-trimmed edge"],
      ["Weight & Feel", "Light with a soft, cushioned hand"],
      ["Opacity", "Semi-opaque — comfortable full coverage"],
      ["Drape", "Soft, relaxed fall that holds its shape"],
      ["Shine", "Natural matte"],
      ["Best For", "Everyday wear, all seasons"],
    ],
    care: "Hand wash cold with a gentle detergent. Dry flat away from sunlight. Do not iron the crochet edge directly.",
  },
  {
    name: "Luxe Crushed Shimmer", slug: "luxe-crushed-shimmer", image: "/images/products/rayaan-gulabi.jpg",
    intro: "A rich crushed texture threaded with light — every fold catches a different glow. The Rayaan collection's fabric — light, caught and held.",
    specs: [
      ["Texture", "Crushed, softly crinkled surface with all-over shimmer"],
      ["Weight & Feel", "Light and airy, forgiving to style"],
      ["Opacity", "Semi-opaque"],
      ["Drape", "Textured, voluminous fall"],
      ["Shine", "Soft all-over shimmer that moves with you"],
      ["Best For", "Occasions, evenings, festive wear"],
    ],
    care: "Hand wash cold and drip dry — the crushed texture resets naturally. Do not wring.",
  },
  {
    name: "Metallic Shimmer", slug: "metallic-shimmer", image: "/images/products/noorah-nuhas.jpg",
    intro: "A smooth reflective finish with a fluid, weightless drape. The Noorah collection's fabric — light made wearable.",
    specs: [
      ["Texture", "Smooth, fine surface with a metallic sheen"],
      ["Weight & Feel", "Very light, cool and fluid"],
      ["Opacity", "Semi-opaque"],
      ["Drape", "Liquid, graceful fall"],
      ["Shine", "Soft metallic glow without glare"],
      ["Best For", "Evenings, celebrations, layering"],
    ],
    care: "Hand wash cold with a gentle detergent. Drip dry away from sunlight. Cool iron on reverse if needed.",
  },
  {
    name: "Embroidered Chiffon", slug: "embroidered-chiffon", image: "/images/products/saher-lulu.jpg",
    intro: "Weightless chiffon scattered with delicate embroidered daisy motifs. The Saher collection's fabric — contrast, perfected.",
    specs: [
      ["Texture", "Smooth chiffon with raised embroidered motifs"],
      ["Weight & Feel", "Feather-light and airy"],
      ["Opacity", "Sheer — layer with an underscarf"],
      ["Drape", "Airy, floating fall"],
      ["Shine", "Soft matte with tonal embroidery detail"],
      ["Best For", "Statement days, gifting, occasions"],
    ],
    care: "Hand wash very gently in cold water. Drip dry in the shade. Cool iron on reverse — never directly on the embroidery.",
  },
  {
    name: "Shimmer Hijab", slug: "shimmer-hijab", image: "/images/products/nazra-anab.jpg",
    intro: "Soft radiance, effortless elegance. The Nazra collection's fabric — a beautiful subtle sheen with an easy, all-day drape.",
    specs: [
      ["Texture", "Softly grained shimmer surface"],
      ["Weight & Feel", "Lightweight and breathable"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Easy, fluid fall"],
      ["Shine", "Beautiful subtle sheen — never glaring"],
      ["Best For", "Everyday elegance, evenings, gifting"],
    ],
    care: "Hand wash cold with a gentle detergent. Drip dry away from sunlight. Cool iron on reverse if needed — never directly over the shimmer surface.",
  },
  {
    name: "Crinkled Stripe Hijab", slug: "crinkled-stripe-hijab", image: "/images/products/raha-turab.jpg",
    intro: "Comfort in every shade. The Raha collection's fabric — soft crinkled striped cotton, breathable and easy to style.",
    specs: [
      ["Texture", "Soft cotton crinkle with clearly woven fine vertical stripes"],
      ["Weight & Feel", "Soft, lightweight and breathable"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Relaxed, easy fall"],
      ["Shine", "Soft matte"],
      ["Best For", "Everyday wear, warm weather, all-day comfort"],
    ],
    care: "Gentle machine or hand wash cold. Air dry — the crinkle resets naturally, no ironing needed.",
  },
  {
    name: "Cotton Floral", slug: "cotton-floral", image: "/images/products/rawda-rayhan.jpg",
    intro: "Soft florals for a kinder, calmer you. The Rawda collection's fabric — breathable premium cotton with a delicate botanical print.",
    specs: [
      ["Texture", "Softly textured woven cotton with a fine stripe"],
      ["Weight & Feel", "Light, soft and breathable"],
      ["Opacity", "Semi-opaque — comfortable coverage"],
      ["Drape", "Relaxed, natural fall"],
      ["Shine", "Natural matte"],
      ["Best For", "Everyday wear, warm weather, gentle styling"],
    ],
    care: "Gentle machine or hand wash cold. Dry in the shade to keep the print fresh. Warm iron on reverse.",
  },
];
